/**
* @Author: zachalam
* @Date:   2017-04-11T11:07:59-07:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-04-11T11:07:59-07:00
*/




import React, { Component } from 'react';
import { browserHistory } from 'react-router';

import { connect } from 'react-redux';
import { saveToken } from '../actions/authActions';
import { refreshProfile } from '../actions/profileActions';
import { clearEverything } from '../actions/commonActions';
import { toast } from 'react-toastify';

class ContinueContainer extends Component {

  componentWillMount() {

    // capture incomming jwt, and log user in.
    let { token, message } = this.props.location.query;

    // attempt to grab profile and log user in
    this.props.tokenLogin(token,message);

    // log the token;
    console.log(token);


  }

  render() {
    return (
      <div>Just a moment..</div>
    );
  }
}


const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    tokenLogin: (token,msg) => {
      // wipe all existing data in active store.
      dispatch(clearEverything());
      // save token
      dispatch(saveToken({token}));
      // retrieve logged in profile.
      dispatch(refreshProfile())
        .then((r) => {
          // we got a profile with this token, redirect user to IndexRoute
          // where they will either be sent to "join-profile" or "dashboard"
          browserHistory.push("/");
          toast(msg);
        })
        .catch((error) => {
          // invalid token.
          browserHistory.push("/logout");
          toast.warn('Invalid Token');
        })
      }
  }
}

export default connect(null,mapDispatchToProps)(ContinueContainer);



// WEBPACK FOOTER //
// ./src/containers/ContinueContainer.jsx